/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `m/s` - m/s
 * @export
 */
export const TimeseriesRainMsUnitEnum = {
  M_S: "m/s",
} as const;
export type TimeseriesRainMsUnitEnum =
  (typeof TimeseriesRainMsUnitEnum)[keyof typeof TimeseriesRainMsUnitEnum];

export function instanceOfTimeseriesRainMsUnitEnum(value: any): boolean {
  for (const key in TimeseriesRainMsUnitEnum) {
    if (Object.prototype.hasOwnProperty.call(TimeseriesRainMsUnitEnum, key)) {
      if (TimeseriesRainMsUnitEnum[key as keyof typeof TimeseriesRainMsUnitEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TimeseriesRainMsUnitEnumFromJSON(json: any): TimeseriesRainMsUnitEnum {
  return TimeseriesRainMsUnitEnumFromJSONTyped(json, false);
}

export function TimeseriesRainMsUnitEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeseriesRainMsUnitEnum {
  return json as TimeseriesRainMsUnitEnum;
}

export function TimeseriesRainMsUnitEnumToJSON(value?: TimeseriesRainMsUnitEnum | null): any {
  return value as any;
}

export function TimeseriesRainMsUnitEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): TimeseriesRainMsUnitEnum {
  return value as TimeseriesRainMsUnitEnum;
}
